import invariant from 'tiny-invariant';
import { TFunction, useTranslation } from 'translations/hooks';

import { useAppContext } from 'business/contextProviders/useAppContext';
import AggregatedGraph from 'business/shift-report/report/pages/ReportAggregated/AggregatedGraph';
import { GetTopLevelCriticalTaskAggregateV1Response } from 'generated/apiSchemas';

interface TopAndSecondLevelChartsProps {
  tasksAggregate: GetTopLevelCriticalTaskAggregateV1Response | undefined;
}

const getNonCriticalChartTitle = (taskName: string, t: TFunction) => {
  return `${taskName} - ${t('pages.print.totalTime')}`;
};

export const TopAndSecondLevelCharts = ({
  tasksAggregate,
}: TopAndSecondLevelChartsProps) => {
  const { t } = useTranslation();
  const { currentConstructionSite } = useAppContext();
  invariant(currentConstructionSite, 'No constructionSite');

  return tasksAggregate ? (
    <>
      <AggregatedGraph
        topLevelTasksAggregate={tasksAggregate.firstLevelAggregation}
        criticalTime
      />
      {currentConstructionSite.aggregatedReportActivityLevel > 1 &&
      tasksAggregate.firstLevelAggregation
        ? Object.entries(tasksAggregate.firstLevelAggregation).map((level) => {
            if (!level?.[1]?.subTasks || level[1].subTasks.length === 0) {
              return null;
            }

            return (
              <AggregatedGraph
                topLevelTasksAggregate={level[1].subTasks}
                title={getNonCriticalChartTitle(level[1].name, t)}
              />
            );
          })
        : null}
    </>
  ) : null;
};
